import { render } from "./announcementTable.vue?vue&type=template&id=2d865824&scoped=true"
import script from "./announcementTable.vue?vue&type=script&lang=js"
export * from "./announcementTable.vue?vue&type=script&lang=js"

import "./announcementTable.vue?vue&type=style&index=0&id=2d865824&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d865824"]])

export default __exports__